var Plan = (function () {
    function Plan(parentContext, rootRequest) {
        this.parentContext = parentContext;
        this.rootRequest = rootRequest;
    }
    return Plan;
}());
export { Plan };
//# sourceMappingURL=plan.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/inversify/es/planning/plan.js
// module id = 1714
// module chunks = 0